module.exports = __webpack_public_path__ + "img/ico-waze.5b68a7c5.svg";